import { CREATE_DMX_UNIVERSE, CREATE_DMX_UNIVERSE_SUCCESSFUL, CREATE_DMX_UNIVERSE_FAILED } from './actionTypes';

export const createDmxUniverse = (universe) => {
  return {
    type: CREATE_DMX_UNIVERSE,
    payload: { universe },
  };
};

export const createDmxUniverseSuccessful = (message) => {
  return {
    type: CREATE_DMX_UNIVERSE_SUCCESSFUL,
    payload: message,
  };
};

export const createDmxUniverseFailed = (message) => {
  return {
    type: CREATE_DMX_UNIVERSE_FAILED,
    payload: message,
  };
};
